module.exports = __webpack_public_path__ + "img/analyse.7dbbad4b.png";